<div class="p-g-12 p-lg-12 p-md-12 assign-search-input-layout">
  <p-autoComplete [dropdown]="true"class="assign search-driver" [ngModel]="multipleAssignments == false ? searchText : searchTextSet" (ngModelChange)="multipleAssignments == false ? searchText : searchTextSet = $event"
  [suggestions]="searchTextResult" (completeMethod)="search($event)" [placeholder]="placeholder"
  [multiple]="multipleAssignments" (onSelect)="onSelect($event)" field="name"
  (onUnselect)="onUnselect($event)" [size]="30">
    <ng-template let-ref pTemplate="item">
      <span style="font-size:18px">{{ref.referrenceNumber}} - {{ref.name}}</span>
    </ng-template>
  </p-autoComplete>
</div>

<div class="form-buttons p-g-12">
  <button pButton type="button" label="{{positiveButtonLabel ? positiveButtonLabel : 'Assign'}}" (click)="assign()"></button>
  <button class="negative-button" pButton type="button" icon="fa fa-close" label="{{negativeButtonLabel ? negativeButtonLabel : 'Cancel'}}"
    (click)="cancel()"></button>
</div>
